import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=64e59b7e"
import script from "./PlanForm.vue?vue&type=script&lang=js"
export * from "./PlanForm.vue?vue&type=script&lang=js"
import style0 from "./PlanForm.vue?vue&type=style&index=0&id=64e59b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports